import { createSelector } from 'reselect';

const selectContractsState = (state) => state.contracts.current;

export const selectContractData = createSelector(selectContractsState, (state) => state.data);
export const selectTransferAgreement = createSelector(selectContractsState, (state) => state.transferAgreement);
export const selectResendInProgress = createSelector(selectContractsState, (state) => state.resendInstructionInProgress);
